<template>
    <Head>
        <title>Configuration - Innovative Scholars</title>
    </Head>
    <PageTitle 
        title="Configuration" 
        subtitle="Update ISMS configurations and settings"
    />
    <div class="container my-6">
        <TabGroup vertical>
            <div class="flex">
                <TabList class="w-full md:w-64 mr-4">
                    <Tab 
                        v-for="tab in tabs" :key="`tab-${tab.tab}`"
                        v-slot="{ selected }"
                        class="w-64 mb-2 focus:outline-none flex items-center"
                    >
                        <div v-if="selected" class="h-7 w-1 bg-primary-500 rounded-full mr-2"></div>
                        <button
                            class="w-full rounded-lg py-2.5 px-4 text-sm font-medium leading-5 text-left text-gray-600 focus:outline-none"
                            :class="[
                            selected
                                ? 'bg-gray-100 text-gray-600 font-semibold'
                                : 'text-white hover:bg-gray-100 hover:text-gray-600',
                            ]"
                        >
                            {{ tab.label }}
                        </button>
                    </Tab>
                </TabList>
                <TabPanels class="w-full">
                    <TabPanel>
                        <div class="border-b pb-2 mb-4">
                            <h2 class="text-xl font-medium"> Customize Environments </h2>
                        </div>
                        <div>
                            <Environments />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div class="border-b pb-2 mb-4">
                            <h2 class="text-xl font-medium"> Online Curriculum </h2>
                        </div>
                        <div>
                            <OnlineCurriculum />
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div class="border-b pb-2 mb-4 flex justify-between">
                            <h2 class="text-xl font-medium"> SLPs </h2>
                            <div id="slp"></div>
                        </div>
                        <div>
                            <StudentLearningPlan :configuration="studentLearningPlan" />
                        </div>
                    </TabPanel>
                </TabPanels>
            </div>
        </TabGroup>
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/inertia-vue3'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'
import PageTitle from '@/Shared/PageTitle'
import Environments from '@/Pages/Configuration/Environments'
import OnlineCurriculum from '@/Pages/Configuration/OnlineCurriculum'
import StudentLearningPlan from '@/Pages/Configuration/StudentLearningPlan'

defineProps({
    studentLearningPlan: {
        type: Object,
        required: true
    }
})

const tabs = [
    {
        tab: 'general',
        label: 'Customize Environments'
    },
    {
        tab: 'student',
        label: 'Online Curriculum'
    },
    {
        tab: 'slps',
        label: 'SLPs'
    }
]
</script>